import React from "react";
import "./Serve.css";
import heroImg from "../../../images/yita.jpeg";

const stats = [
  { number: "50", suffix: "+", label: "Doctors & Medical Team Members" },
  { number: "1,000", suffix: "+", label: "Patients Served" },
  { number: "20", suffix: "", label: "Partner Facilities" },
  { number: "24", suffix: "/7", label: "Emergency Availability" },
];

export default function Serve() {
  return (
    <section className="scope-section" aria-labelledby="scope-heading">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Left: Content */}
          <div className="col-lg-7 col-md-12" data-aos="fade-right">
            <div className="scope-label">
              <ion-icon name="globe-outline"></ion-icon>
              Our Scope
            </div>
            <h2 className="scope-heading" id="scope-heading">
              Yita Life - Scope of Services &amp; Products
            </h2>
            <p className="scope-description">
              We offer an extensive range of standard-quality healthcare services
              for both preventive and curative modern medicine, using mobile and
              outdoor healthcare approaches. We leverage advanced technologies
              and good clinical practice methods to serve clients in urban and
              remote areas alike.
            </p>
            <p className="scope-description">
              Our multidisciplinary team of specialists, general doctors, nurses,
              midwives, physiotherapists, laboratory and pharmacy experts is
              backed by an international advisory board. We dream of
              revolutionising equitable healthcare access across Uganda and
              Africa.
            </p>

            {/* Stats */}
            <div className="stats-grid" data-aos="fade-up" data-aos-delay="100">
              {stats.map((s, i) => (
                <div className="stat-card" key={i}>
                  <div className="stat-card-number">
                    {s.number}<span>{s.suffix}</span>
                  </div>
                  <div className="stat-card-label">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="col-lg-5 col-md-12 scope-img-col" data-aos="fade-left" data-aos-delay="100">
            <div className="scope-img-wrapper">
              <img src={heroImg} alt="Yita Life Medical Team in the Field" />
              <div className="scope-img-overlay">
                <div className="scope-img-text">
                  Revolutionising Healthcare <br /> Across Uganda &amp; Africa
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
